// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"ea1846cb","297":"461a9975","300":"75bc9c0f","305":"4637d951","605":"939e5c66","719":"9c901a88","779":"d1e789bc","811":"83bd666c","995":"561ed17e"}[chunkId] + ".chunk.css";
};